// extracted by mini-css-extract-plugin
module.exports = {"spacer":"W_dr","title":"W_7"};